import * as React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
  TextField
} from '@mui/material';
import { Icon } from '@iconify/react';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import { LoadingButton } from '@mui/lab';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import request from '../../utils/request';
import SnackbarAlert from '../common/SnackbarAlert';

export default function CancelEndorsementDialog({

  endorsementId,
  pageContent = 'Endorsement',
  closeModal
}) {
  const [loader, setLoader] = React.useState(false);
  const [showSnackBarAlert, setShowSnackBarAlert] = React.useState({
    status: false,
    type: 'success',
    message: null
  });

  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  const formik = useFormik({
    initialValues: {
      reason: ''
    },
    validationSchema: Yup.object({
      reason: Yup.string()
        .min(2, 'Minimum 2 characters required')
        .required('Reason for cancellation is required')
    }),
    onSubmit: (values) => {
      setLoader(true);
      request({
        url: 'endorsement/cancelEndorsement',
        method: 'post',
        data: {
          id: endorsementId,
          reason: values.reason.trim()
        }
      })
        .then((res) => {
          if (res?.status) {
            setShowSnackBarAlert({
              status: true,
              type: 'success',
              message: 'Endorsement cancelled successfully.'
            });
            closeModal();
          } else {
            setShowSnackBarAlert({
              status: true,
              type: 'error',
              message: res['message'] || 'Failed to cancel endorsement.'
            });
          }
        })
        .catch(() => {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: 'Something went wrong. Please try again later.'
          });
        })
        .finally(() => setLoader(false));
    }
  });

  return (
    <>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />

      <Dialog
        open={true}
        onClose={() => closeModal()}
        aria-labelledby="cancel-dialog-title"
        aria-describedby="cancel-dialog-description"
      >
        <DialogTitle id="cancel-dialog-title" style={{ paddingBottom: '0px' }}>
          <Grid container spacing={1} alignItems="center">
            <Grid item>
              <Icon icon={trash2Outline} width={22} height={22} color="red" />
            </Grid>
            <Grid item>
              <Typography variant="h6" color="black" sx={{ textTransform: 'capitalize' }}>
                Cancel {pageContent}
              </Typography>
            </Grid>
          </Grid>
        </DialogTitle>

        <form onSubmit={formik.handleSubmit}>
          <DialogContent style={{ paddingTop: '10px' }}>
            <DialogContentText sx={{ mb: 2 }}>
              Are you sure you want to cancel this {pageContent.toLowerCase()}?
            </DialogContentText>

            <TextField
              fullWidth
              multiline
              rows={3}
              label={
                <React.Fragment>
                  Reason for cancellation{' '}
                  <Typography component="span" sx={{ color: 'red' }}>
                    *
                  </Typography>
                </React.Fragment>
              }
             
              variant="outlined"
              name="reason"
              value={formik.values.reason}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.reason && Boolean(formik.errors.reason)}
              helperText={formik.touched.reason && formik.errors.reason}
            />
          </DialogContent>

          <DialogActions>


            <LoadingButton
              loading={loader}
              variant="contained"
              type="submit"
              color="primary"
            >
              Cancel Endorsement
            </LoadingButton>
            <Button color="error" variant="contained" onClick={() => closeModal()} >
              Close
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}
